import { useSelector } from "../../../../redux-store";
import {
  selectCargoDriverTimeTrackingTotalTime,
  selectPauseTime,
  selectTimeSpent,
  selectTotalWeight,
  selectWeightCargoEvents,
} from "../../../../ducks/data/cargo-events/selectors";
import { useL10n } from "../../../../l10n";
import { useTranslation } from "react-i18next";
import { PlannedLocation } from "../../../../ducks/data/cargo-events/types";

const WeightEventsTotalWeightAndTimeSpent = ({
  cargoId,
}: {
  cargoId: string;
}) => {
  const { t } = useTranslation(["shipmentModal"]);
  const l10n = useL10n();
  const weightEvents = useSelector(selectWeightCargoEvents(cargoId));
  const totalWeight = useSelector(selectTotalWeight(cargoId));
  const timeSpent = useSelector(selectTimeSpent(cargoId));
  const pauseTime = useSelector(selectPauseTime(cargoId));
  const totalTime = useSelector(selectCargoDriverTimeTrackingTotalTime(cargoId));

  const renderPlannedLocation = (plannedLocation: PlannedLocation) => {
    if (!plannedLocation) {
      return null;
    }
    if (plannedLocation.city) {
      return plannedLocation.city;
    }
    if (plannedLocation.place) {
      return plannedLocation.place;
    }
  };

  return (
    <>
      {weightEvents.length ? (
        <div className="shipment-dialog__total-weight">
          <div className="shipment-dialog__shipment-stat">
            <div>{t("shipmentModal:totalWeight")}</div>
            <div>{l10n.formatNumber(totalWeight)} kg</div>
          </div>
          <div className="total-weight__hover">
            {weightEvents.map((e, i) => (
              <div key={i}>
                {renderPlannedLocation(e.plannedLocation)} -{" "}
                {l10n.formatNumber(e.weight)} kg
              </div>
            ))}
          </div>
        </div>
      ) : null}
      {timeSpent && (
        <div className="shipment-dialog__shipment-stat">
          <div>{t("shipmentModal:timeUsed")}</div>
          <div>
            {timeSpent ? t("shipmentModal:hoursAndMinutes", timeSpent) : "-"}
          </div>
        </div>
      )}
      {pauseTime && (
        <div className="shipment-dialog__shipment-stat">
          <div>{t("shipmentModal:pauseTime")}</div>
          <div>
            {pauseTime ? t("shipmentModal:hoursAndMinutes", pauseTime) : "-"}
          </div>
        </div>
      )}
      {totalTime && (
        <div className="shipment-dialog__shipment-stat">
          <div>{t("shipmentModal:totalTime")}</div>
          <div>
            {totalTime ? t("shipmentModal:hoursAndMinutes", totalTime) : "-"}
          </div>
        </div>
      )}
    </>
  );
};

export default WeightEventsTotalWeightAndTimeSpent;
